module.exports = __webpack_public_path__ + "img/gzbgs.b7c568d0.png";